import FetchAPI from "../../helpers/FetchAPI";
import {TypeMethodContsantEnum} from "../../helpers/constant/MethodAPIConstant";

class CateContractService extends FetchAPI {
    public async list(data) {
        const result = await this.request(
            "cate/mail/index",
            data,
            TypeMethodContsantEnum.GET
        );
        return result;
    }

    public async find(id) {
        const result = await this.request(
            `cate/mail/find/${id}`,
            {},
            TypeMethodContsantEnum.GET
        );
        return result;
    }

    public async store(data) {
        const result = await this.request(
            "cate/mail/store",
            data,
            TypeMethodContsantEnum.POST
        );
        return result;
    }

    public async update(data) {
        const result = await this.request(
            "cate/mail/update",
            data,
            TypeMethodContsantEnum.POST
        );
        return result;
    }

    public async delete(id) {
        const result = await this.request(
            "cate/mail/delete",
            {id},
            TypeMethodContsantEnum.DELETE
        );
        return result;
    }
}

export default CateContractService;
